export const RECEIVE_THUMBS = 'iHR/Tracks/RECEIVE_THUMBS';
export const RECEIVE_TRACKS = 'iHR/Tracks/RECEIVE_TRACKS';
